import React, { useState } from 'react';
import './CustomisedForm.css';

const SOURCE_OPTIONS = [
  'Friend / Family Referral',
  'School / College Recommendation',
  'Google Search',
  'Social Media (Instagram / Facebook)',
  'YouTube',
  'LinkedIn',
  'WhatsApp',
  'Newspaper / Magazine',
  'Event / Hackathon',
  'ibots Website',
  'Other',
];

const errStyle = { color: '#e8394d', fontSize: '11px', marginTop: '4px' };

function CustomisedForm({ onClose, isCollege = false }) {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    fullName: '', phone: '', email: '', institution: '',
    programme: '', duration: '', customDuration: '',
    domains: '', goals: '', source: '', customSource: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = 'Full name is required';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.goals) newErrors.goals = 'Please describe your learning goals';
    if (!formData.source) newErrors.source = 'Please tell us how you heard about ibots';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setTimeout(() => {
        const firstError = document.querySelector('.error-field');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
      return;
    }

    try {
      await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formType:    isCollege ? 'customised-college' : 'customised-school',
          fullName:    formData.fullName,
          phone:       formData.phone,
          email:       formData.email,
          institution: formData.institution,
          programme:   formData.programme,
          duration:    formData.duration,
          domains:     formData.domains,
          goals:       formData.goals,
          source:      formData.source === 'Other' ? formData.customSource : formData.source,
        }),
      });
    } catch (err) {
      console.log('Your backend error:', err);
    }

    try {
      await fetch('http://localhost:5000/api/centre', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
  name:            formData.fullName,
  type: isCollege ? 'College' : 'School',
  phone:           formData.phone,
  email:           formData.email,
  institution:     formData.institution,
  grade:           formData.programme || '',
  mode:            'Offline',
  formType:        'Customised Learning',
  domainOfInterest: formData.domains === 'other' ? formData.customDomains || '' : formData.domains || '',
  goals:           formData.goals || '',
  duration:        formData.duration === 'other' ? formData.customDuration : formData.duration || '',
  source:          formData.source === 'Other' ? formData.customSource : formData.source,
}),
      });
    } catch (err) {
      console.log('Training dashboard error:', err);
    }

    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="cf__overlay" onClick={onClose}>
        <div className="cf__box" onClick={(e) => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', gap: '16px' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#dcfce7', color: '#16a34a', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900 }}>✓</div>
          <h2 style={{ color: '#0d2e6e', fontWeight: 900, margin: 0 }}>Thank You for Reaching Out to ibots!</h2>
          <p style={{ color: '#64748b', margin: 0, maxWidth: '300px', lineHeight: '1.6' }}>We have received your customised learning path request. Our team will get in touch with you within <strong>24 hours</strong> with a tailored programme plan.</p>
          <button className="cf__submit" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="cf__overlay" onClick={onClose}>
      <div className="cf__box" onClick={(e) => e.stopPropagation()}>

        <button className="cf__close" onClick={onClose}>✕</button>
        <h2 className="cf__title">Customised Learning Path — Request Form</h2>
        <p className="cf__subtitle">Tell us your goals and we will design the perfect programme. Our team will respond within 24 hours.</p>

        <div className="cf__form">

          <div className="cf__row">
            <div className="cf__group">
              <label className="cf__label">Full Name *</label>
              <input type="text" name="fullName" value={formData.fullName}
                onChange={handleChange} placeholder="Enter your full name" className="cf__input" />
              {errors.fullName && <p style={errStyle} className="error-field">{errors.fullName}</p>}
            </div>
            <div className="cf__group">
              <label className="cf__label">Phone Number *</label>
              <input type="text" name="phone" value={formData.phone}
                onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="cf__input" />
              {errors.phone && <p style={errStyle} className="error-field">{errors.phone}</p>}
            </div>
          </div>

          <div className="cf__row">
            <div className="cf__group">
              <label className="cf__label">Email Address *</label>
              <input type="email" name="email" value={formData.email}
                onChange={handleChange} placeholder="you@example.com" className="cf__input" />
              {errors.email && <p style={errStyle} className="error-field">{errors.email}</p>}
            </div>
            <div className="cf__group">
              <label className="cf__label">Institution Name</label>
              <input type="text" name="institution" value={formData.institution}
                onChange={handleChange}
                placeholder={isCollege ? "College / University name" : "School name"}
                className="cf__input" />
            </div>
          </div>

          <div className="cf__row">
            <div className="cf__group">
              <label className="cf__label">{isCollege ? 'Programme & Year' : 'Grade / Standard'}</label>
              <input type="text" name="programme" value={formData.programme}
                onChange={handleChange}
                placeholder={isCollege ? "e.g. B.E. ECE, 3rd Year" : "e.g. Grade 8"}
                className="cf__input" />
            </div>
            <div className="cf__group">
              <label className="cf__label">Preferred Duration</label>
              <select name="duration" value={formData.duration}
                onChange={handleChange} className="cf__input cf__select">
                <option value="">Select...</option>
                <option value="1month">1 Month</option>
                <option value="2months">2 Months</option>
                <option value="3months">3 Months</option>
                <option value="4months">4 Months</option>
                <option value="6months">6 Months</option>
                <option value="custom">Custom Duration</option>
              </select>
              {formData.duration === 'custom' && (
                <input type="text" name="customDuration" value={formData.customDuration}
                  onChange={handleChange} placeholder="e.g. 45 days, 10 weeks..."
                  className="cf__input cf__input--mt" />
              )}
            </div>
          </div>

          <div className="cf__group cf__group--full">
            <label className="cf__label">Domains of Interest</label>
            <input type="text" name="domains" value={formData.domains}
              onChange={handleChange}
              placeholder="e.g. Embedded Systems + AI + Drone Technology"
              className="cf__input" />
          </div>

          <div className="cf__group cf__group--full">
            <label className="cf__label">Describe Your Learning Goals *</label>
            <textarea name="goals" value={formData.goals} onChange={handleChange}
              placeholder="What do you want to build? What career are you targeting? Any prior experience or specific requirements?"
              className="cf__input cf__textarea" />
            {errors.goals && <p style={errStyle} className="error-field">{errors.goals}</p>}
          </div>

          <div className="cf__group cf__group--full">
            <label className="cf__label">How did you hear about ibots? *</label>
            <select name="source" value={formData.source}
              onChange={handleChange} className="cf__input cf__select">
              <option value="">Select...</option>
              {SOURCE_OPTIONS.map((s) => (<option key={s} value={s}>{s}</option>))}
            </select>
            {errors.source && <p style={errStyle} className="error-field">{errors.source}</p>}
            {formData.source === 'Other' && (
              <input type="text" name="customSource" value={formData.customSource}
                onChange={handleChange} placeholder="Please tell us how you found us..."
                className="cf__input cf__input--mt" />
            )}
          </div>

          <button className="cf__submit" onClick={handleSubmit}>
            Submit Request →
          </button>

        </div>
      </div>
    </div>
  );
}

export default CustomisedForm;